import Polyglot from 'node-polyglot'
import {withProps} from 'recompose'

import tha from './tha.json'

export const polyglot = new Polyglot()
polyglot.extend(tha)

export const translate = polyglot.t.bind(polyglot)

export const withTranslate = withProps({
  t: translate
})
